import React from "react";
import SendArrowIcon from "../SendArrowIcon";

const CardWithdrawIcon = () => {
  return (
    <div>
      <div className="w-[42px] h-[42px] relative">
        <div className="flex items-center justify-center w-10 h-10 left-0 top-0 absolute bg-transaction-debit-icon-bg rounded-full">
          <svg
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.06641 0H20.9336C22.073 0 23 0.938 23 2.09091V13.9091C23 15.062 22.073 16 20.9336 16H2.06641C0.927008 16 0 15.062 0 13.9091V2.09091C0 0.938 0.927008 0 2.06641 0ZM5.57031 8.00253C6.46206 8.00253 7.1875 7.26848 7.1875 6.36616V5.27525C7.1875 4.37293 6.46206 3.63889 5.57031 3.63889H4.49219C3.60044 3.63889 2.875 4.37293 2.875 5.27525V6.36616C2.875 7.26848 3.60044 8.00253 4.49219 8.00253H5.57031ZM16.4277 10.0791C16.2719 10.0791 16.115 10.0281 15.9832 9.92297C15.6715 9.67429 15.6179 9.21702 15.8637 8.90156C16.0652 8.64301 16.1717 8.3317 16.1717 8.00138C16.1717 7.67106 16.0652 7.35974 15.8637 7.10115C15.6179 6.78574 15.6715 6.32842 15.9832 6.07974C16.2949 5.83115 16.7469 5.8852 16.9926 6.20065C17.3902 6.71101 17.6092 7.35051 17.6092 8.00138C17.6092 8.65224 17.3902 9.29174 16.9926 9.80206C16.8508 9.98411 16.6403 10.0791 16.4277 10.0791ZM18.2115 11.8809C18.4085 11.8809 18.6047 11.7994 18.7466 11.6394C19.6348 10.6378 20.124 9.34452 20.124 7.99775C20.124 6.65098 19.6348 5.35766 18.7466 4.35612C18.4815 4.05716 18.0271 4.03234 17.7316 4.30057C17.4362 4.5688 17.4116 5.02862 17.6767 5.32757C18.3279 6.06184 18.6865 7.01012 18.6865 7.99775C18.6865 8.98539 18.3279 9.93366 17.6767 10.6679C17.4116 10.9668 17.4362 11.4267 17.7316 11.6949C17.8689 11.8196 18.0405 11.8809 18.2115 11.8809Z"
              fill="url(#paint0_linear_6252_57978)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_6252_57978"
                x1="0.5"
                y1="1"
                x2="23"
                y2="14.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.149" stopColor="#2B2D42" />
                <stop offset="0.52" stopColor="#495867" />
                <stop offset="0.814" stopColor="#2B2D42" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div className="w-4 h-4 right-0.5 top-6 absolute bg-primary-300 rounded-full border-2 border-primary-300">
          <SendArrowIcon />
        </div>
      </div>
    </div>
  );
};

export default CardWithdrawIcon;
